module.exports = __webpack_public_path__ + "assets/5ccba751735a5ba903308fe0ed075f83.mp3";